import React from 'react';
import { Loader2, Check, AlertTriangle } from 'lucide-react';
import type { SaveStatus } from '../contexts/SaveStatusContext';

interface SaveIndicatorProps {
  status: SaveStatus;
}

export function SaveIndicator({ status }: SaveIndicatorProps) {
  // Don't show anything in idle state
  if (status.status === 'idle') {
    return null;
  }

  return (
    <div className="flex items-center gap-2 text-xs font-medium transition-all">
      {status.status === 'saving' && (
        <>
          <Loader2 size={14} className="animate-spin text-blue-600 dark:text-blue-400" />
          <span className="text-blue-600 dark:text-blue-400">Saving...</span>
        </>
      )}

      {status.status === 'saved' && (
        <>
          <Check size={14} className="text-green-600 dark:text-green-400" />
          <span className="text-green-600 dark:text-green-400">Saved</span>
        </>
      )}

      {status.status === 'error' && (
        <div className="flex items-center gap-2" title={status.message}>
          <AlertTriangle size={14} className="text-yellow-600 dark:text-yellow-400" />
          <span className="text-yellow-600 dark:text-yellow-400">Error</span>
        </div>
      )}
    </div>
  );
}
